import React from 'react';
import classNames from 'classnames';
import styles from './select.module.scss';
import useValidateValue from '../CreateAccount/hooks/useValidationHook';
import { Country } from '../../pages/GTBCustomize/ContextProviders/SharedContextTypes';
import { buildCountriesSelect, buildStatesSelect, shouldSelectBeDisabled } from './helpers';
import { FormChangeEvent } from '../../pages/GTBCustomize/ContextProviders/SharedContext';

interface SelectProps {
  countries: Country[],
  name: string,
  value: string,
  label: string,
  handleOnChange: (event: FormChangeEvent) => void,
  currentCountryCode: string,
  withPadding: boolean,
  errorMessage: string,
}

const Select: React.FunctionComponent<SelectProps> = (
  {
    countries,
    value,
    handleOnChange,
    name,
    label,
    currentCountryCode,
    withPadding,
    errorMessage,
  }: SelectProps,
): JSX.Element => {
  const { validationClass, validateValue, isInvalid } = useValidateValue();
  const isDisabled = shouldSelectBeDisabled(name, countries, currentCountryCode);
  const isInvalidAndNotDisabled = isInvalid && !isDisabled;

  return (
    <div className={classNames(styles.inputWrapper, { [styles.inputPadding]: withPadding })}>
      <div className={styles.inputContainer}>
        <label className={styles.inputLabel} htmlFor={name}>
          {label}
          <select
            id={name}
            className={classNames(styles.select, { [validationClass]: isInvalidAndNotDisabled })}
            name={name}
            value={value}
            onChange={(evt) => {
              handleOnChange(evt);
              validateValue(name, evt.target.value);
            }}
            disabled={isDisabled}
            data-testid={name}
          >
            {name === 'shipCountry'
              ? buildCountriesSelect(countries)
              : buildStatesSelect(countries, currentCountryCode)}
          </select>
          {isInvalidAndNotDisabled && <p className={styles.inputError}>{errorMessage}</p>}
        </label>
      </div>
    </div>
  );
};

export default Select;
